import * as crypto from "crypto-browserify/index.js";
import { parse, parseISO, isValid } from 'date-fns';

export function getReplaceTitle(title) {
    let title_el = document.querySelector("title");
    if (title_el)
        title_el.innerHTML = title
}

export function getHash(string) {
    console.log("getHash(string)---------------: ", string)
    return crypto.createHash('sha256').update(string).digest('hex');
}

export function getOrderIndex(name) {
    switch (name) {
        case 'nombres':
            return 1
        case 'apellido paterno':
            return 2
        case 'apellido materno':
            return 3
        case 'curp':
            return 4
        case 'clave de elector':
            return 5
        case 'Número CIC':
            return 6
        case 'Número de OCR':
            return 7
        case 'anno de emisión':
            return 8
        case 'numero emision':
            return 9
        case 'anno de registro':
            return 10
        case 'vigencia':
            return 11
        case 'direccion':
            return 12
        case 'fecha de nacimiento':
            return 13
        case 'sexo':
            return 14
        case 'MetadataNombre':
            return 1
        case 'MetadataApellidoPaterno':
            return 2
        case 'MetadataApellidoMaterno':
            return 3
        case 'MetadataCURP':
            return 4
        case 'MetadataClaveElector':
            return 5
        case 'MetadataNúmeroCIC':
            return 6
        case 'MetadataNúmeroOCR':
            return 7
        case 'MetadataAñoEmisión':
            return 8
        case 'MetadataNúmeroEmisión':
            return 9
        case 'MetadataAñoRegistro':
            return 10
        case 'MetadataVigencia':
            return 11
        case 'MetadataDirección':
            return 12
        case 'MetadataFechaNacimiento':
            return 13
        default:
            return 500
    }
}

export const blobToBase64 = blob => {
    try {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        return new Promise(resolve => {
            reader.onloadend = () => {
                resolve(reader.result);
            };
        });
    } catch (e) {
        console.log("blobToBase64: ", e)
    }
};

// export const B64toBlobAsync = async (b64Data, contentType = '', sliceSize = 512) => {
//     let atob = require('atob');
//     const byteCharacters = atob(b64Data);
//     const byteArrays = [];

//     for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
//         const slice = byteCharacters.slice(offset, offset + sliceSize);

//         const byteNumbers = new Array(slice.length);
//         for (let i = 0; i < slice.length; i++) {
//             byteNumbers[i] = slice.charCodeAt(i);
//         }

//         const byteArray = new Uint8Array(byteNumbers);
//         byteArrays.push(byteArray);
//     }

//     const blob = new Blob(byteArrays, { type: contentType });
//     return blob;
// }

export const B64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = window.atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}


export const Uint8ArraytoB64 = (uint8ArrayData) => {
    // console.log("convert uint8ArrayData----------------:  ", uint8ArrayData)
    let b64 = Buffer.from(uint8ArrayData).toString('base64')
    // console.log("convert bg4----------------:  ", b64)
    return b64;
}


export const PadLeft = (value, length) => {
    return (value.toString().length < length) ? PadLeft("0" + value, length) :
        value;
}

export const ClearSession = () => {
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('userName')
    sessionStorage.removeItem('WorkFlowData')
}

export const convertPdfToB64 = async (file) => {
    const fileConverted = await toBase64Async(file);
    const base64result = fileConverted.split(",")[1];
    // const wordUrl = URL.createObjectURL(file);
    // return { base64result, wordUrl };
    return { base64result }
};

export const b64toUrl = async (base64Data) => {
    const r = await fetch(base64Data);
    const blob = await r.blob();
    return URL.createObjectURL(blob);
};

export const B64toBlobFetch = async (base64Data, type = "data:application/pdf;base64") => {
    const r = await fetch(`${type},${base64Data}`);
    const blob = await r.blob();
    return blob;
};

export const dataUrlToFile = async (base64Data, fileName, type = "data:application/pdf;base64", mimeType = 'image/jpg') => {
    const r = await fetch(`${type},${base64Data}`);
    const blob = await r.blob();
    return new File([blob], fileName, { type: mimeType });
}

const toBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

const toBase64Async = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}

export function obtenerDireccionIP(callback) {
    const xhr = new XMLHttpRequest();
    xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
            const respuesta = JSON.parse(xhr.responseText);
            const ip = respuesta.ip;
            callback(ip);
        } else {
            callback(null);
        }
    };
    xhr.open('GET', 'https://api.ipify.org?format=json');
    xhr.send();
}

export function clearCacheData() {
    return new Promise((resolve, reject) => {
        caches.keys().then((names) => {
            // Delete all the cache files
            names.forEach(name => {
                caches.delete(name);
            })
        });
        resolve("Ejecucion correcta")
    });
}

export const GenerateRandom = () => {
    const randomArray = new Uint32Array(1);
    window.crypto.getRandomValues(randomArray);
    const randomValue = randomArray[0];
    return randomValue;
}

export const GetMimeType = (extension) => {
    if (extension == ".jpg" || extension == ".jpge") {
        return "data:image/jpeg;base64"
    } else if (extension == ".jpg") {
        return "data:image/png;base64"
    } else {
        return "data:application/pdf;base64"
    }
}

export const IsDevice = () => {
    let IsAndroid = navigator.userAgent.match(/Android/i) ? true : false
    let IsIOS = navigator.userAgent.match(/iPhone/i) ? true : false
    let IsMobile = (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/iPhone/i)) ? true : false

    return { IsAndroid, IsIOS, IsMobile }
}


export const ValidarSICumpleCondiciones = (expresion, value1, value2) => {
    if (expresion.toUpperCase() == "equals".toUpperCase() || expresion == "==") {
        return value1 == value2;
    } else if (expresion.toUpperCase() == "not equals".toUpperCase() || expresion == "!=" || expresion == "<>") {
        return value1 != value2;
    }else {
        return false
    }
}

export const generateUniqueId = () => {
    const timestamp = Date.now(); // Obtiene el timestamp actual
    const randomNum = Math.floor(Math.random() * 10000); // Genera un número aleatorio
    return `${timestamp}-${randomNum}`;
}

export const parseDate = (dateString) => {
    const formats = [
        'dd/MM/yyyy',
        'yyyy-MM-dd',
        'yyyy-MM-dd\'T\'HH:mm:ss.SSSX',
        'dd MMM yyyy'
    ];
    // Intentar parsear como ISO primero
    let date = parseISO(dateString);
    if (isValid(date)) return date;
    // Intentar otros formatos
    for (const formatString of formats) {
      date = parse(dateString, formatString, new Date());
      if (isValid(date)) return date;
    }
    // Si no se puede parsear, devolver null o lanzar un error
    return null;
  };

export const handleErrorMessage = (error) => {
  return (
    error?.response?.data?.Messages ||
    error?.response?.data?.message ||
    error?.message ||
    "Un error desconocido ocurrió"
  );
};
